
import { apiRequest } from '../services/ApiService.js';
import history from '../utility/common/History.js';
import { HSAMaxImageSize, inArray } from '../utility/common/GlobalHSA.js';

import {
  PARTNER_SET_LOADING,

  PARTNER_UPDATE_ASSISTANT_FAIL,
  PARTNER_UPDATE_ASSISTANT_SUCCESS,

  PARTNER_UPDATE_WEB_FAIL,
  PARTNER_UPDATE_WEB_SUCCESS,

  PARTNER_GET_AGENT_SUCCESS,
  PARTNER_GET_AGENT_FAIL,

  PARTNER_GET_CLIENTDETAILS,
  PARTNER_GET_CLIENTDETAILS_SUCCESS,
  PARTNER_GET_CLIENTDETAILS_FAIL,

  SNACKBAR_SET,
  PARTNER_SET_PERSONAL_DATA,
  PARTNER_BANKING_IMAGE_ADD,
  PARTNER_BANKING_IMAGE_ADD_SUCCESS,
  PARTNER_BANKING_IMAGE_ADD_FAILED,

  PARTNER_BANKING_IMAGE_RESET,
  AUTH_USER_UPDATE_SUCCESS_MERGE,

  PARTNER_UPDATE_DATA,

  AUTH_PARTNER_FAIL,

  PARTNER_GET_BANKING_SUCCESS,
  PARTNER_SET_BANKING_SUCCESS,

  GENERAL_REQUEST_LOADING } from './types';

/*--------------------- Set Employer Data ----------------------*/

export const updatePartnerData = (inputGroup, inputName, inputValue) => {
  return (dispatch) => {
    dispatch({ type: PARTNER_UPDATE_DATA, datagroup: inputGroup, dataname: inputName, datavalue: inputValue });
  };
};

// ******************************************************************** //
/* Get Client Details */
// ******************************************************************** //
export const gotoEmployerDetails = (er) => {
  const url = "/partner/employer/" + er;
  history.push(url);
  return (dispatch) => {
    dispatch({
      type: PARTNER_GET_CLIENTDETAILS
    });
  };
};

// ******************************************************************** //
/* Get Employer Details */
// ******************************************************************** //
export const getEmployerDetails = (agentId, token, erId) => {
  return (dispatch) => {

    dispatch({
      type: PARTNER_GET_CLIENTDETAILS
    });

    const data = { token, agentId, erId };
    const responseDispatches = { success: PARTNER_GET_CLIENTDETAILS_SUCCESS, fail: PARTNER_GET_CLIENTDETAILS_FAIL };
    const showSnackBar = { fail: true, success: true };

    apiRequest(dispatch, history, token, '/partner/clientdetails', data, responseDispatches, null , showSnackBar, null, true, true);

  };
};
// ******************************************************************** //
/* Get Partner Details */
// ******************************************************************** //
export const getPartnerDetails = (token, agentId, requestedId) => {
  return (dispatch) => {
    const data = {agentId: agentId, requestedId: requestedId}
    const endpoint = '/partner/agent';
    const responseDispatches = { success: PARTNER_GET_AGENT_SUCCESS, fail: PARTNER_GET_AGENT_FAIL };
    const showSnackBar = {fail: true, success: false};

    apiRequest(dispatch, history, token, endpoint, data, responseDispatches, null , showSnackBar);

  }
};
// ******************************************************************** //
/* Save Personal Partner Info */
// ******************************************************************** //
export const savePartnerPersonalInfo = (agentId, token, presonalData) => {
  return (dispatch) => {
    dispatch({
      type: PARTNER_SET_PERSONAL_DATA
    });
  
    const data = {
      token,
      agentId,
      data: presonalData
    }
    const endpoint = '/partner/personal/update';
    const responseDispatches = { success: AUTH_USER_UPDATE_SUCCESS_MERGE, fail: null };
    const showSnackBar = {fail: true, success: true};
  
    apiRequest(dispatch, history, token, endpoint, data, responseDispatches, null , showSnackBar, null, true);
  
  };
};

// ******************************************************************** //
/* Save Partner Assistant Info */
// ******************************************************************** //
export const savePartnerAssistantInfo = (token, agentId, assistant_data, assistant_number) => {
  return (dispatch) => {
    dispatch({ type: PARTNER_SET_LOADING });
    const data = { agentId: agentId, ...assistant_data, assistant_number: assistant_number }
    const endpoint = '/partner/assistant/save';
    const responseDispatches = { fail: PARTNER_UPDATE_ASSISTANT_FAIL, success: PARTNER_UPDATE_ASSISTANT_SUCCESS };
    const showSnackBar = { fail: true, success: true };

    apiRequest(dispatch, history, token, endpoint, data, responseDispatches, null, showSnackBar);
  
  }
};

// ******************************************************************** //
/* Save Partner Web Info */
// ******************************************************************** //
export const savePartnerWebInfo = (token, agentId, web_data) => {
  return (dispatch) => {
    dispatch({ type: PARTNER_SET_LOADING });
    const data = { agentId: agentId, ...web_data }
    const responseDispatches = { fail: PARTNER_UPDATE_WEB_FAIL, success: PARTNER_UPDATE_WEB_SUCCESS };
    const showSnackBar = { fail: true, success: true };
    const endpoint = '/partner/web/save';

    apiRequest(dispatch, history, token, endpoint, data, responseDispatches, null, showSnackBar);
  
  }
};

// ******************************************************************** //
/* Get Partner Banking Details */
// ******************************************************************** //
export const authGetPartnerBankingDetails = (token, partnerId) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {partnerId: partnerId};
    const endpoint = '/partner/banking-details';
    const responseDispatches = { fail: AUTH_PARTNER_FAIL, success: PARTNER_GET_BANKING_SUCCESS };
    const showSnackBar = { fail: true, success: false };

    apiRequest(dispatch, history, token, endpoint, data, responseDispatches, null, showSnackBar);

  };
};

// ******************************************************************** //
/* Set Partner Banking Details */
// ******************************************************************** //
export const authSetPartnerBankingDetails = (token, partnerId, transitNumber, institutionNumber, accountNumber, imageObj, eft_agreement) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const endpoint = '/partner/banking-details/save';
    const responseDispatches = { fail: AUTH_PARTNER_FAIL, success: PARTNER_SET_BANKING_SUCCESS };
    const showSnackBar = { fail: true, success: true };
    const responseFunctions = {fail: partnerBankingImageReset, success: partnerBankingImageReset};
    const data = {partnerId: partnerId, 
      transitNumber: transitNumber, 
      institutionNumber: institutionNumber, 
      accountNumber: accountNumber, 
      eft_agreement: (eft_agreement)? 'Y' : 'N', 
      image: imageObj};

    apiRequest(dispatch, history, token, endpoint, data, responseDispatches, null, showSnackBar, responseFunctions);

  };
};

// ******************************************************************** //
/* Set Cheque Image */
// ******************************************************************** //
export const partnerBankingImageAdd = (imageObj) => {
  return (dispatch) => {
    dispatch({ type: PARTNER_BANKING_IMAGE_ADD, imageObj });
    processPartnerBankingImageAdd(dispatch, imageObj);
  }
}

// ******************************************************************** //
const processPartnerBankingImageAdd = (dispatch, imageObj) => {

  let error = false;
  let errors = {};

  const responseDispatches = { fail: PARTNER_BANKING_IMAGE_ADD_FAILED, success: PARTNER_BANKING_IMAGE_ADD_SUCCESS };
  const responseRedirects = { fail: null, success: null };
  const showSnackBar = { fail: true, success: true };

  if(typeof imageObj !== "object") { error = true; errors.GENERAL = 'Invalid banking document'; }

  //check if valid file types
  if(!inArray(['image/jpeg','image/png','application/pdf'],imageObj.type)) { error = true; errors.GENERAL = 'Invalid document type, please choose a JPEG, PNG, or PDF'; }

  //check if size is bigger than 4mb
  if(imageObj.size > HSAMaxImageSize) { error = true; errors.GENERAL = 'Maximum document size cannot exceed 5MB.'; }

  if(error === false) {
    partnerBankImageUploadSuccess(
      dispatch,
      imageObj,
      'Banking document attached',
      responseDispatches.success,
      responseRedirects.success,
      showSnackBar.success
    );
  } else {
    errors.GENERAL = (errors.GENERAL)? errors.GENERAL : 'Could not add banking document';
    partnerBankImageUploadFail(
      dispatch,
      error,
      errors,
      responseDispatches.fail,
      responseRedirects.fail,
      showSnackBar.fail
    );
  }

}

// ******************************************************************** //
export const partnerBankingImageReset = () => {
  return (dispatch) => {
    dispatch({ type: PARTNER_BANKING_IMAGE_RESET });
  }
}

// ******************************************************************** //
const partnerBankImageUploadSuccess = (
  dispatch,
  data,
  message,
  responseDispatch,
  responseRedirect,
  showSnackBar
) => {
  dispatch({
    type: responseDispatch,
    data,
  });
  if(showSnackBar === true){
    dispatch({
      type: SNACKBAR_SET,
      message: message,
      severity: 'notificationBarSuccess',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
  if(responseRedirect) history.push(responseRedirect);
};

// ******************************************************************** //
const partnerBankImageUploadFail = (
  dispatch,
  error,
  errors,
  responseDispatch,
  responseRedirect,
  showSnackBar
) => {
  dispatch({
    type: responseDispatch,
    error,
    errors
  });
  if(showSnackBar === true){
    dispatch({
      type: SNACKBAR_SET,
      message: errors.GENERAL,
      severity: 'notificationBarFailed',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
  if(responseRedirect) history.push(responseRedirect);
};
